// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"h7-z"};